export const getInitials = (name: string): string => {
  const parts = name.split(' ');

  if (parts.length === 1) {
    return name.substring(0, 2);
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`;
};

export const getEnumeration = (
  strings: (string | number)[],
  options: {
    glueString: {
      common: string;
      last: string;
    };
  } = { glueString: { common: ', ', last: ', ' } },
): string => {
  if (!strings || !Array.isArray(strings) || !strings.length) {
    return '';
  }

  const head = [
    ...strings.filter((x) => {
      return typeof x === 'string' || typeof x === 'number';
    }),
  ];
  const tail = head.pop()?.toString() || '';

  return [head.join(options.glueString.common), tail].filter((x) => !!x).join(options.glueString.last);
};

export const toTitleCase = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/(^|[\s,-])\p{L}/gu, (char) => char.toUpperCase());
};
